import { DecimalPipe, formatNumber } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "minutesToHours",
})
export class MinutesToHoursPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}
  transform(value: number, formatString?: string): string {
    if (!formatString) {
      const sign = value < 0 ? "-" : "";
      const absValue = Math.abs(value);
      const hours = Math.floor(absValue / 60);
      const minutes = absValue % 60;
      return sign + hours + ":" + (minutes < 10 ? '0' : '') + minutes;
    }
    return this.decimalPipe.transform(value / 60, formatString);
  }
}
